export default __webpack_public_path__ + "static/media/1954.b8e232df.png";